<template>
	<div class="login-page-container" a_id="forgot-password-container" extension-name="forgot-password">
		<div class="login-page-header"
			 a_id="forgot-password-header">{{'ForgotPasswordPage.ForgotPasswordHeaderStart' | translate}}<br>
			<b>{{'ForgotPasswordPage.ForgotPasswordHeaderEnd' | translate}}</b></div>

		<div class="forgot-password-description"
			 a_id="forgot-password-description">
			{{'ForgotPasswordPage.ForgotPasswordDecription' | translate}}
		</div>

		<login-page-field
				a_id="forgot-password-field-email"
				v-model="email"
				:title="'ForgotPasswordPage.Email' | translate"
				:placeholder="'ForgotPasswordPage.Email' | translate"
				:image-type="'userName'"
				@enter="resetClicked"/>

		<div class="login-page-footer"
			 a_id="forgot-password-footer">
			<a class="login-page-footer-link"
			   href="#"
			   @click="backButtonClicked"
			   a_id="forgot-password-back-link">{{'LoginPage.Backlink' | translate}}</a>
			<button v-if="email"
					class="login-page-footer-button-right"
					@click="resetClicked"
					a_id="forgot-password-reset-button">
				{{'LoginPage.ResetPassword' | translate}}
			</button>
			<button v-else
					class="login-page-footer-button-right"
					@click="resetClicked"
					disabled
					a_id="forgot-password-reset-button-disabled">{{'LoginPage.ResetPassword' | translate}}
			</button>
		</div>
	</div>
</template>

<script>
	import BasePage from './BasePage.vue';
	import LoginPageField from './LoginPageField.vue';
	import LoginService from '../services/LoginService';
	import UrlService from '../../../common/services/src/url/urlService';

	export default BasePage.extend({
		name: "ForgotPasswordPage",
		props:{
			"currentAccountId" : {
				type: String,
				required: false
			}
		},
		methods: {
			backButtonClicked(){
				this.$emit("navigate", "LoginSignInPage");
			},
			resetClicked(){
				if( !this.email ){
					return;
				}
				let accountId = this.currentAccountId || UrlService.getSearchParam("accountId") || UrlService.getSearchParam("account");
				LoginService.recoverPassword(accountId, 'loginapplicationkey', this.email).then(
					(res) => {
						this.$emit('notify',
							this.translateService.getString('ForgotPasswordPage.SendEmailSuccess'),
							this.translateService.getString('ForgotPasswordPage.SendEmailSuccessMessage'));
					},
					(err) => {
						this.$emit('notify',
							this.translateService.getString('ForgotPasswordPage.SendEmailFailure'),
							this.extractErrorMessage(err.data.message));
					}
				);
			},
		},
		data(){
			return {
				email: '',
			};
		},
		components: {
			LoginPageField
		},
		model: {
			// Parent can use "v-model" (by default, the expected event's name is "input")
			event: "navigate"
		},
		dependencies: [{
			translateService : 'com.jacada.common.services.TranslateService'
		}]
	});
</script>

<style lang="scss">
	@import '../sass/loginPage.scss';

	.login-page-container {

		.forgot-password-description{
			line-height: $line-height;
			font-size: $font-size;
			max-width: 365px;
			margin-top: 55px;
		}

	}

</style>


// WEBPACK FOOTER //
// src/app/ForgotPasswordPage.vue